import { FC, memo } from "react"
import GiftSpecialService from "./installments"
import styles from "./index.module.scss"


interface IProps {
    workInInstallments: boolean
}


const SpecialServices: FC<IProps> = ({ workInInstallments }) => {


    return (
        <div className={styles.special_services + " mt-md"}>
            <ul className={styles.list__special_services + " mb-md flex flex-column gap-15"}>
                <li>
                    {
                        workInInstallments &&
                        <GiftSpecialService />
                    }
                </li>


                <li className={styles.item__list + " flex align-i-center gap-15"}>
                    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M33.875 18.8334V11.7334C33.875 5.01672 32.23 3.33337 25.615 3.33337H12.385C5.77 3.33337 4.125 5.01672 4.125 11.7334V30.5C4.125 34.9334 6.68002 35.9834 9.77752 32.8167L9.79498 32.8C11.23 31.35 13.4175 31.4667 14.66 33.05L16.4275 35.3" stroke="#292D32" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        <path d="M29.85 35.6667C32.9428 35.6667 35.45 33.2789 35.45 30.3334C35.45 27.3878 32.9428 25 29.85 25C26.7572 25 24.25 27.3878 24.25 30.3334C24.25 33.2789 26.7572 35.6667 29.85 35.6667Z" stroke="#292D32" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        <path d="M36.5 36.6667L34.75 35" stroke="#292D32" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        <path d="M12 11.6666H26" stroke="#292D32" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        <path d="M13.75 18.3334H24.25" stroke="#292D32" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>


                    <div className={styles.content__item}>
                        <h4>
                            سفته‌ تضمین قرارداد
                        </h4>
                        <p>
                            از طریق قراردادهای معتبر و سفته، پایبندی متخصص به تعهدات تضمین شده است.
                        </p>
                    </div>
                </li>
            </ul>
        </div>
    )
}

export default memo(SpecialServices)